import React from 'react';
import { Section } from './Section';
import { Target } from 'lucide-react';
export function MechanismSection() {
  return <Section data-id="element-77">
      <div className="max-w-4xl mx-auto text-center" data-id="element-78">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-accent/10 rounded-full mb-8 border border-accent/20" data-id="element-79">
          <Target className="w-10 h-10 text-accent" data-id="element-80" />
        </div>
        <h2 className="text-4xl md:text-6xl font-bold text-white uppercase mb-8 leading-tight" data-id="element-81">
          La Secuencia de Asalto de{' '}
          <span className="text-accent" data-id="element-82">180 Minutos</span>
        </h2>
        <div className="bg-tactical-light border border-accent/30 p-8 md:p-12 text-center relative overflow-hidden" data-id="element-83">
          <div className="absolute top-0 left-0 w-1 h-full bg-accent" data-id="element-84" />
          <p className="text-xl md:text-2xl text-zinc-300 leading-relaxed mb-6" data-id="element-85">
            La Maquinaria de Enfoque utiliza la Secuencia de Asalto de 180
            Minutos. No intentamos gestionar tu tiempo; hackeamos tus ciclos
            circadianos y flujos de dopamina para condensar una semana de
            trabajo en tres horas de ejecución violenta e ininterrumpida.
          </p>
          <p className="text-2xl md:text-3xl font-oswald text-white uppercase tracking-wide" data-id="element-86">
            Es pasar del modo "ocupado" al modo{' '}
            <span className="text-accent" data-id="element-87">"operador"</span>.
          </p>
        </div>
      </div>
    </Section>;
}